<template>
    <header>
        <div class="row">
            <router-link class="col-5 logo" to="/">
                ORIGIN'S PROD'S
            </router-link>
            <router-link class="col-2 img-logo-container" to="/">
                <img src="../assets/image/only_logo_orginsprod_black.png" alt="Logo" class="logo-img" />
            </router-link>
            <div class="col-3 menu-button-container">
                <button class="menu-button" @click="show_menu();">
                    <span class="menu-button-title"> MENU</span>
                    <span class="menu-button-logo">
                        <span></span>
                        <span></span>
                    </span>
                </button>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: "HeaderComponent",
        methods: {
            show_menu: function(){
                var menu_background = document.getElementById("menu-background");
                var menu_content = document.getElementById("menu-content");

                var first_span = document.querySelector('.menu-button-logo').firstChild;
                var last_span = document.querySelector('.menu-button-logo').lastChild;

                var body = document.querySelector('body');

                if(menu_background.style.visibility == "visible"){
                    menu_background.style.opacity = 0;
                    menu_background.style.visibility = "hidden";

                    menu_content.style.transform = "translateX(100%)";

                    first_span.style.transform = "none";
                    first_span.style.top = "0";
                    last_span.style.transform = "none";
                    last_span.style.top = "0";

                    body.style.overflow = "unset";
                }
                else {
                    menu_background.style.opacity = 0.4;
                    menu_background.style.visibility = "visible";

                    menu_content.style.transform = "none";

                    first_span.style.transform = "rotate(45deg) scaleX(1)";
                    first_span.style.top = "4px";
                    last_span.style.transform = "rotate(-45deg) scaleX(1)";
                    last_span.style.top = "-3px";

                    body.style.overflow = "hidden";
                }
            }
        }
    };
</script>

<style lang="scss">
    header {
        width: 100%;
        margin-top: 2em;
        margin-bottom: 2em;
    }

    .logo {
        font-weight: bold;
        padding-left: 3%;
        font-size: 1.5em;
        text-decoration: none;
        color: #000;
    }

    .logo:hover {
        text-decoration: none;
        color: #000;
        cursor: pointer;
    }

    .img-logo-container {
        text-align: center;
    }

    .logo-img {
        height: 5.1em;
        width: auto;
    }

    .menu-button-container {
        margin-left: auto;
    }

    .menu-button {
        width: 80%;
        border: none;
        background: #FFF;
        text-align: right;
    }

    .menu-button-title {
        display: inline-block;
        color: #000;
        margin: 0 25px 0 0;
    }

    .menu-button-logo {
        position: fixed;
        top: 2.2em;
        display: inline-block;
        width: 1.5em;
        line-height: 1.5em;
        vertical-align: text-bottom;
        z-index: 251;
    }

    .menu-button-logo span {
        position: relative;
        display: block;
        width: 100%;
        height: 2px;
        margin: 5px 0;
        z-index: 1;
        background: #000;
        top: 0;
        ;
        transition: transform 0.3s;
    }

    .menu-button-logo::before {
        content: "";
        display: block;
        position: absolute;
        top: -1em;
        bottom: -1em;
        right: -1em;
        left: -1em;
        border-radius: 100%;
    }

    .menu-button:hover {

        .menu-button-logo::before {
            background: #000;
        }

        .menu-button-logo span {
            background: #FFF;
        }
    }

    @media (max-width: 690px) {
        .menu-button-logo {
            right: 1em;
        }
    }

    @media (max-width: 420px) {
        .menu-button-logo {
            top: 2em;
        }
    }

    @media (max-width: 340px) {
        .menu-button-logo {
            top: 1.8em;
        }
    }
</style>